export default __webpack_public_path__ + "static/media/NotoSans-SemiBoldItalic.5e2265b6.ttf";